/**
 * Server-defined view type for filtering issue timeline items.
 * The server resolves each value to the appropriate set of item types internally.
 */
export const IssueTimelineViewType = {
  CONVERSATION: 'CONVERSATION',
  ACTIVITY: 'ACTIVITY',
} as const

export type IssueTimelineViewType = (typeof IssueTimelineViewType)[keyof typeof IssueTimelineViewType]
